import graphql__8ee355df3944776d00a7 from "./__generated__/ContributionContent_contribution.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import ExcerptableContainer from "../Utils/ExcerptableContainer";
import { highlight } from "../../helpers/StringHelper";

const ContributionContent = ({ highlightTerms, ...props }) => {
  const contribution = useFragment(ContributionContent_contribution, props.contribution);
  const { participativeModule } = contribution;
  const { collapseContributionsContent, contributionContentCollapsedHeight } =
    participativeModule;

  const content = useMemo(
    () => highlight(contribution.content, highlightTerms),
    [contribution.content, highlightTerms]
  );

  return (
    <ExcerptableContainer
      className="contribution-content"
      collapsible={collapseContributionsContent}
      collapsedHeight={contributionContentCollapsedHeight}
      maskContainerRef={props.ref}
    >
      {content}
    </ExcerptableContainer>
  );
};

const ContributionContent_contribution = graphql__8ee355df3944776d00a7;

export default ContributionContent;
